import { render, staticRenderFns } from "./faqEdit.vue?vue&type=template&id=c37d9c66&scoped=true"
import script from "./faqEdit.vue?vue&type=script&lang=js"
export * from "./faqEdit.vue?vue&type=script&lang=js"
import style0 from "./faqEdit.vue?vue&type=style&index=0&id=c37d9c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37d9c66",
  null
  
)

export default component.exports